import api from '../../api/api'
import userService from '../../services/user.service'


const UPDATE_SUCCESS    = 'UPDATE_SUCCESS',
      GETTING_INFO      = 'GET_INFO',
      GET_INFO_SUCCESS  = 'GET_INFO_SUCCESS',
      UPDATE_PROCESS    = 'UPDATE_PROCESS',
      GETTING_BD_INFO      = 'GETTING_BD_INFO',
      GET_BD_INFO_SUCCESS  = 'GET_BD_INFO_SUCCESS',
      GET_PRODDATE_SUCCESS  = 'GET_PRODDATE_SUCCESS',
      GET_PROD_SUCCESS  = 'GET_PROD_SUCCESS',
      GET_BONUSDATE_SUCCESS = 'GET_BONUSDATE_SUCCESS',
      GET_BONUS_SUCCESS = 'GET_BONUS_SUCCESS',
      SET_ERROR  = 'SET_ERROR',
      SET_PICKED = 'SET_PICKED',
      SET_INDEX = 'SET_INDEX',
      SET_SEND  = 'SET_SEND',
      SET_HISTORY_DEPTO = 'SET_HISTORY_DEPTO',
      SET_HISTORY_CITY = 'SET_HISTORY_CITY';
    //   UPDATE_TEXT_BTN   = 'UPDATE_TEXT_BTN';

export default {
    namespaced: true,
    state:{
        notification: 'Guardar',
        loading: false,
        flag: false,
        data: [],
        bd: [],
        chartBonos: {},
        chartBonosFecha: {},
        chartProduccion: {},
        chartProduccionFecha: {},
        surveyError: false,
        picked: false,
        index: '',
        sendBtnText: 'Enviar',
        sendFlag: false,
        historyDepto: 'corte',
        historyCity: userService.cityUser(userService.getToken())
    },
    getters: {
        getNotif(state){
            return state.notification;
        },
        loading(state) {
            return state.loading;
        },
        flag(state) {
            return state.flag;
        },
        data(state) {
            return state.data;
        },
        bd(state) {
            return state.bd;
        },
        chartBonos(state){
            return state.chartBonos;
        },
        chartBonosFecha(state){
            return state.chartBonosFecha;
        },
        chartProduccion(state){
            return state.chartProduccion;
        },
        chartProduccionFecha(state){
            return state.chartProduccionFecha;
        },
        getsurveyError(state){
            return state.surveyError;
        },
        getpickedAnswer(state){
            return state.picked;
        },
        getchoice(state){
            return state.index;
        },
        sendFlag(state){
            return state.sendFlag;
        },
        sendText(state){
            return state.sendBtnText;
        },
        getHistoryDepto(state){
            return state.historyDepto
        },
        getHistoryCity(state){
            return state.historyCity
        }
    },
    mutations: {
        [GETTING_INFO](state) {
            state.loading = true;
            state.data = [];
        },
        [GET_INFO_SUCCESS](state, change) {
            state.loading = false;
            state.data = change;
        },
        [UPDATE_SUCCESS](state, change){
            state.flag = true;
            state.notification = change;
        },
        [UPDATE_PROCESS](state){
            state.notification = 'Guardar';
            state.flag = false;
        },
        [GETTING_BD_INFO](state) {
            state.loading = true;
            state.bd = [];
        },
        [GET_BD_INFO_SUCCESS](state, change) {
            state.loading = false;
            state.bd = change;
        },
        [GET_PRODDATE_SUCCESS](state, change){
            state.chartProduccionFecha = change;
        },
        [GET_PROD_SUCCESS](state, change){
            state.chartProduccion = change;
        },
        [GET_BONUSDATE_SUCCESS](state, change){
            state.chartBonosFecha = change;
        },
        [GET_BONUS_SUCCESS](state, change){
            state.chartBonos = change;
        },
        [SET_ERROR](state, change){
            state.surveyError = change;
        },
        [SET_PICKED](state, change){
            state.picked = change;
        },
        [SET_INDEX](state, change){
            state.index = change;
        },
        [SET_SEND](state, change){
            state.sendFlag = change.flag;
            state.sendBtnText = change.text;
        },
        [SET_HISTORY_CITY](state, change){
            state.historyCity = change;
        },
        [SET_HISTORY_DEPTO](state, change){
            state.historyDepto = change;
        },
    },
    actions: {
        async editInfo({ commit }, payload) {
            commit(UPDATE_PROCESS);
            try {
              let response = await api.editInfo(payload.base, payload.dias_sucios, payload.extra_m3, payload.depto, payload.city);
              commit(UPDATE_SUCCESS, 'Cambios guardados');
              return response.data;
            } catch (error) {
             //console.log(error);
            }
        },
         async editMontoBase({ commit }, payload) {
           // console.log(payload)
            commit(UPDATE_PROCESS);
            if(payload.depto =='vigueta'){
                try {
                    let response = await api.editMontoBaseII(payload.monto_base, payload.depto, payload.city);
                    commit(UPDATE_SUCCESS, 'Cambios guardados');
                    return response.data;
                  } catch (error) {
                   //console.log(error);
                  }
            }else if(payload.depto =='insulpanel'){
                try {
                    let response = await api.editMontoBaseII(payload.monto_base, payload.depto, payload.city);
                    commit(UPDATE_SUCCESS, 'Cambios guardados');
                    return response.data;
                  } catch (error) {
                   //console.log(error);
                  }
            }else{
                try {
                    let response = await api.editMontoBase(payload.monto_base, payload.depto, payload.city);
                    commit(UPDATE_SUCCESS, 'Cambios guardados');
                    return response.data;
                  } catch (error) {
                   //console.log(error);
                  }
            }
            /*commit(UPDATE_PROCESS);
            try {
              let response = await api.editMontoBase(payload.monto_base, payload.depto, payload.city);
              commit(UPDATE_SUCCESS, 'Cambios guardados');
              return response.data;
            } catch (error) {
             //console.log(error);
            }
            */
        },
        async getInfo({ commit }, payload) {
            commit(GETTING_INFO);
            let depto = payload.department;
            try {               
                let normalizedDepto = depto.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f-\s]/g, "");                     
                let response = await api.getDeptoInfo(normalizedDepto, payload.city, payload.userCode);
                commit(GET_INFO_SUCCESS, response.data);
                return response.data;
               // console.log(response.data)
            } catch (error) {
              // console.log(error);
            }
        },

        async getWeek({ commit }, payload) {
           
            try {               
                let response = await api.getWeek(payload);
                return response.data;
            } catch (error) {
              // console.log(error);
            }
        },
        async getBDInfo({ commit }, payload) {    
            commit(GETTING_BD_INFO);
            let depto = payload.department;
            try {                                
                let normalizedDepto = depto.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f-\s]/g, "");                               
                let response = await api.getBDInfo(normalizedDepto, payload.city);
                commit(GET_BD_INFO_SUCCESS, response.data);
                //console.log(response.data)
                return response.data;
            } catch (error) {
               //console.log(error);
            }
        },
        async getAllInfo({ commit }, payload) {
           // console.log(payload)
          
            commit(GETTING_INFO);
            let depto = payload.department;
            try {                                
                let normalizedDepto = depto.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f-\s]/g, "");                
                let response = await api.getDashboardInfo(normalizedDepto, payload.city);
                commit(GET_INFO_SUCCESS, response.data);
                return response.data;
            } catch (error) {
               //console.log(error);
            }
        },
        async getBonos({commit}, payload){
            try{
                let city = payload.cityName;
                let dep = payload.depName;
                let linkcity;
                let produccion = [];
                let fechas = [];
                let bonos = [];
               
                let linkdepto = dep.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f-\s]/g, "");
                city == 'La Paz'? linkcity = city.toLowerCase().replace(/ /g,"") : linkcity = city.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f-\ ]/g, "");

               
                let response = await api.getBonos(linkdepto, linkcity);
                bonos = response.data.bonos;
                let len = bonos.length;

                for(let i = 0; i < len; i++){                    
                    fechas.push(bonos[i].semana)
                }
                commit(GET_BONUSDATE_SUCCESS, fechas);

                for(var i = 0; i < len; i++){
                    produccion.push(bonos[i].bono)
                }
                commit(GET_BONUS_SUCCESS, produccion);

            }catch(error){
               //console.log(error);
            }
        },
        async getProduccion({commit}, payload){
            try{
                let city = payload.cityName;
                let dep = payload.depName;
                let linkcity;
                let produccion = [];
                let prod = [];
                let fechas = [];
                
                let linkdepto = dep.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f-\ ]/g, "");
                city == 'La Paz'? linkcity = city.toLowerCase().replace(/ /g,"") : linkcity = city.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f-\ ]/g, "");
                
                if(linkdepto != 'mantenimiento' && linkdepto != 'vigueta'  && linkdepto != 'bonogarantia'  && linkdepto != 'insulpanel'){
                    let response = await api.getProduccion(linkdepto, linkcity);
                    produccion = response.data.produccion;
                    let len = produccion.length;
    
                    for(let i = 0; i < len; i++){                    
                        fechas.push(produccion[i].semana)
                    }

                    for(let i = 0; i < len; i++){
                        prod.push(produccion[i].produccion)
                    }
                }
               
                commit(GET_PRODDATE_SUCCESS, fechas);

               
                commit(GET_PROD_SUCCESS, prod);   
            }catch(error){
               //console.log(error);
            }
        },
        surveyError({commit}, payload){   
            commit(SET_ERROR, payload);            
        },
        pickedAnswer({commit}, payload){
            commit(SET_PICKED, payload);  
        },
        setSelectedIndex({commit}, payload){
            commit(SET_INDEX, payload);  
        },
        setHistoryDepto({commit}, payload){
           
            commit(SET_HISTORY_DEPTO, payload);  
        },
        setHistoryCity({commit}, payload){
           
            commit(SET_HISTORY_CITY, payload);  
        },
        async sendSurveyInfo({commit}, payload){
                //console.log(payload.surveyAnswers);
                //console.log(payload.uid);
           
            try {
                let token = userService.getToken();
                let identity = userService.decode(token);
                 let userInfo = {
                     name: identity.name,
                     num: identity.num,
                     depto: identity.depto,
                     city: identity.city
                 }
                let user = {
                    user: userInfo,
                    survey: payload.surveyAnswers,
                }
                let headers = { "Content-Type": "application/x-www-form-urlencoded" };
                let response = await api.sendSurvey(user, headers);
                 console.log(response);
                
                 commit(SET_SEND, payload);

                 return response;
             } catch (error) {
              //console.log(error)
             }


        },
        async sendSurveyInfoEmail({commit}, payload){
            //console.log(payload.surveyAnswers);
            //console.log(payload.uid);
       
        try {
            let token = userService.getToken();
            let identity = userService.decode(token);
             let userInfo = {
                 name: identity.name,
                 num: identity.num,
                 depto: identity.depto,
                 city: identity.city
             }
            let user = {
                user: userInfo,
                survey: payload.surveyAnswers,
            }
            let headers = { "Content-Type": "application/x-www-form-urlencoded" };
            let response = await api.sendSurveyEmail(user, headers);
             console.log(response);
            
             commit(SET_SEND, payload);

             return response;
         } catch (error) {
          //console.log(error)
         }


    },
        
    }
}

